<template>
    <div class="lastpage">
      <img v-if="!isPortrait" v-lazy="preText + '/assets/~/media/images/activity/kiamall/pc/last.jpg'" alt="" />
      <img v-if="isPortrait" v-lazy="preText + '/assets/~/media/images/activity/kiamall/mob/last.jpg'" alt="" />
    <!-- button -->
    <div v-if="isPortrait" class="kv-button" @click="clickKvButton()" code-stm="event, PAGEURL, kv_下载APP_按钮点击"></div>
    </div>
  </template>
  
  <script>
  import { isPortraitFun } from "@/utils/utils.js";
  import lazyLoad from "@/utils/lazyLoad.js";
  
  export default {
    directives: {
      lazy: lazyLoad
    },
    data() {
      return {
        isPortrait: isPortraitFun(),
        preText:'https://www.kia.cn',
      };
    },
    created: function () {
      if (!window.location.href.includes("https://www.kia.cn")) {
        this.preText = 'https://uat.kia.cn'
      }else{
        this.preText = 'https://www.kia.cn'
      }
      console.log('this.preText last', this.preText);
    },
    methods: {
      clickKvButton: function () {
        if (this.isPortrait) {
          //mob
          window.open('https://app-web.kia.cn/kia_wap/#/pages/recommendation/register/index?oneId=1008271312312000803', '_blank');
        } 
      },
      
    },
  };
  </script>
  
  <style lang="scss" scoped>
  
  
  @media (min-width: 767px) {
    .lastpage {
        position: relative;
        height: calc(611 / 1920 * 100vw);
        width: 100%;
        user-select: none;
        z-index: 0;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  @media (max-width: 767px) {
    .lastpage {
        height: calc(834 / 750 * 100vw);
        position: relative;
        width: 100%;
        user-select: none;
        z-index: 0;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .kv-button {
        position: absolute;
        top: calc(233 / 750 * 100vw);
        left: calc(233 / 750 * 100vw);
        width: calc(284 / 750 * 100vw);
        height: calc(78 / 750 * 100vw);
        background-color: transparent;
    }
  }
  </style>